import { Component, Input } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { ConfigServiceService } from 'src/app/services/config-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-button-type1',
  templateUrl: './button-type1.component.html',
  styleUrls: ['./button-type1.component.scss']
})
export class ButtonType1Component {
  @Input() item: any;
  customField1:any;
  fontFamily: string ; 

  public serverPath = environment.commonImageApi + '/home/';

  ngOnInit() {
    
  }

  constructor(
    private commonService: CommonService,
  ) {

  }

  link(url) {

    window.open(url, '_blank')



  }
  

  openInNewWindow(url: string) {
    if (url) {
      const fullURL = this.prependProtocol(url);
      window.open(fullURL, '_blank');


    }
  }

  prependProtocol(url: string): string {
    if (!url.includes('http://') && !url.includes('https://')) {
      return 'https://' + url;
    }
    return url;
  }



}
